// =============================================================================
// Appointment Notification Models
// src/app/core/models/appointment-notification.model.ts
// =============================================================================

/**
 * Types of appointment notifications
 */
export enum AppointmentNotificationType {
  GUEST_BOOKING = 'GUEST_BOOKING',
  APPOINTMENT_CONFIRMED = 'APPOINTMENT_CONFIRMED',
  APPOINTMENT_CANCELLED_BY_PATIENT = 'APPOINTMENT_CANCELLED_BY_PATIENT'
}

/**
 * Labels for notification types in Arabic
 */
export const NOTIFICATION_TYPE_LABELS: Record<AppointmentNotificationType, string> = {
  [AppointmentNotificationType.GUEST_BOOKING]: 'حجز موعد جديد',
  [AppointmentNotificationType.APPOINTMENT_CONFIRMED]: 'تأكيد موعد',
  [AppointmentNotificationType.APPOINTMENT_CANCELLED_BY_PATIENT]: 'إلغاء موعد'
};

/**
 * Icons for notification types
 */
export const NOTIFICATION_TYPE_ICONS: Record<AppointmentNotificationType, string> = {
  [AppointmentNotificationType.GUEST_BOOKING]: 'event_available',
  [AppointmentNotificationType.APPOINTMENT_CONFIRMED]: 'check_circle',
  [AppointmentNotificationType.APPOINTMENT_CANCELLED_BY_PATIENT]: 'cancel'
};

/**
 * Colors for notification types
 */
export const NOTIFICATION_TYPE_COLORS: Record<AppointmentNotificationType, string> = {
  [AppointmentNotificationType.GUEST_BOOKING]: 'primary',
  [AppointmentNotificationType.APPOINTMENT_CONFIRMED]: 'accent',
  [AppointmentNotificationType.APPOINTMENT_CANCELLED_BY_PATIENT]: 'warn'
};

/**
 * Appointment Notification Response DTO
 * Matches backend AppointmentNotificationResponse
 */
export interface AppointmentNotificationResponse {
  id: number;
  
  // Notification details
  notificationType: AppointmentNotificationType;
  title: string;
  message: string;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
  
  // Appointment details
  appointmentId: number;
  appointmentDate: string;
  appointmentTime: string;
  tokenNumber?: number;
  
  // Patient details
  patientId: number;
  patientName: string;
  patientPhone?: string;
  
  // Doctor details
  doctorId: number;
  doctorName: string;
  
  // Computed time ago string from backend
  timeAgo: string;
}

/**
 * Notification Summary Response (for dropdown)
 * Matches backend NotificationSummaryResponse
 */
export interface NotificationSummaryResponse {
  unreadCount: number;
  recentNotifications: AppointmentNotificationResponse[];
  hasMore: boolean;
  totalCount: number;
}

/**
 * Notification Page Response
 * Matches backend NotificationPageResponse
 */
export interface NotificationPageResponse {
  notifications: AppointmentNotificationResponse[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  hasPrevious: boolean;
  hasNext: boolean;
}
